module.exports = __webpack_public_path__ + "img/electric_pending_zone.55feda2e.svg";